import { isRouteErrorResponse, useRouteError } from '@/shared/modern-router';

export const FiscalDataEmployerRegistrationsErrorBoundary = () => {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    return (
      <h1>
        {error.status} {error.statusText}
      </h1>
    );
  }

  return (
    <h1>
      {error instanceof Error
        ? error.message
        : typeof error === 'string'
          ? error
          : 'Unexpected error'}
    </h1>
  );
};

FiscalDataEmployerRegistrationsErrorBoundary.displayName =
  'FiscalData.EmployerRegistrations.ErrorBoundary';
